(function () {
  'use strict';

  function setExpanded(root, expanded, moveFocus) {
    var toggle = root.querySelector('.ps-pdp-callback__toggle');
    var panel = root.querySelector('.ps-pdp-callback__panel');
    if (!toggle || !panel) return;

    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    panel.setAttribute('aria-hidden', expanded ? 'false' : 'true');
    panel.classList.toggle('is-open', expanded);
    root.classList.toggle('is-open', expanded);

    if (expanded) {
      panel.removeAttribute('inert');
      if (moveFocus) {
        window.requestAnimationFrame(function () {
          var name = root.querySelector('.ps-pdp-callback__name');
          if (name) name.focus();
        });
      }
    } else {
      if (panel.contains(document.activeElement)) toggle.focus();
      panel.setAttribute('inert', '');
    }
  }

  function initRoot(root) {
    if (!root || root.dataset.callbackReady === 'true') return;

    var toggle = root.querySelector('.ps-pdp-callback__toggle');
    var panel = root.querySelector('.ps-pdp-callback__panel');
    if (!toggle || !panel) return;

    toggle.addEventListener('click', function () {
      setExpanded(root, toggle.getAttribute('aria-expanded') !== 'true', true);
    });

    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        event.preventDefault();
        setExpanded(root, false, false);
      }
    });

    if (window.__ps5youc && typeof window.__ps5youc.initLeadcap === 'function') {
      var sourceBase = root.getAttribute('data-lead-source-base') || 'pdp-callback';
      var sourceFallback = root.getAttribute('data-lead-source-fallback') || '';
      function sourceForVariant(sku) {
        var cleanSku = String(sku || '').trim();
        if (cleanSku) return sourceBase + '-' + cleanSku;
        return sourceFallback ? sourceBase + '-' + sourceFallback : sourceBase;
      }
      var source = root.getAttribute('data-lead-source') || sourceBase;
      var leadConfig = {
        root: root,
        source: source,
        leadTag: source,
        formType: 'product_callback',
        weMode: root.getAttribute('data-we-mode') || 'known_user_upliance',
        requireWebhook: true,
        trackKnownUser: true,
        includePhoneInAnalytics: false,
        defaultError: root.querySelector('.ps-pdp-callback__error')
          ? root.querySelector('.ps-pdp-callback__error').textContent.trim()
          : 'Enter a valid 10-digit mobile number.',
        inputErrorClass: 'ps-pdp-callback__phone--error',
        selectors: {
          form: '.ps-pdp-callback__form',
          country: '.ps-pdp-callback__country',
          phone: '.ps-pdp-callback__phone',
          name: '.ps-pdp-callback__name',
          submit: '.ps-pdp-callback__submit',
          honeypot: '.ps-pdp-callback__honeypot',
          error: '.ps-pdp-callback__error',
          success: '.ps-pdp-callback__success',
          privacy: '.ps-pdp-callback__privacy'
        },
        extraPayload: function () {
          return {
            product_id: root.getAttribute('data-product-id') || '',
            product_handle: root.getAttribute('data-product-handle') || '',
            product_title: root.getAttribute('data-product-title') || ''
          };
        }
      };
      window.__ps5youc.initLeadcap(leadConfig);

      function updateSourceForVariant(event) {
        var variant = event && event.detail && event.detail.variant;
        if (!variant) return;

        var nextSource = sourceForVariant(variant.sku);
        leadConfig.source = nextSource;
        leadConfig.leadTag = nextSource;
        root.setAttribute('data-lead-source', nextSource);
        root.setAttribute('data-default-sku', variant.sku || '');
      }

      function removeVariantListener(event) {
        if (event.target && event.target.contains && event.target.contains(root)) {
          document.removeEventListener('variant:change', updateSourceForVariant);
          document.removeEventListener('shopify:section:unload', removeVariantListener);
        }
      }

      document.addEventListener('variant:change', updateSourceForVariant);
      document.addEventListener('shopify:section:unload', removeVariantListener);
    }

    root.dataset.callbackReady = 'true';
  }

  function initWithin(container) {
    if (!container || !container.querySelectorAll) return;
    if (container.matches && container.matches('[data-pdp-callback]')) initRoot(container);
    container.querySelectorAll('[data-pdp-callback]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initWithin(document);
    }, { once: true });
  } else {
    initWithin(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initWithin(event.target);
  });

  document.addEventListener('click', function (event) {
    document.querySelectorAll('[data-pdp-callback].is-open').forEach(function (root) {
      if (root.contains(event.target)) return;
      setExpanded(root, false, false);
    });
  });
})();
